import { Button, ButtonGroup } from "@vds/buttons";
import { Modal, ModalBody, ModalTitle } from "@vds/modals";
import { DropdownSelect } from "@vds/selects";
import { useEffect, useState } from "react";
import TreeViewComponent from "./TreeViewComponent";
import { useDispatch, useSelector } from "react-redux";
import { patchWidgetConfig } from "../../store/actions";
import {getCVAppLocationData, getCVAppLocationDataFromAppName, filterRoisWithCvappsAndSiteids} from "../../global/utility/Utils"
import { v4 as uuidv4 } from "uuid";
import { Loader } from "@vds/loaders";
import { ModalActionsContainer, ModalBodyContent } from "./styles";
import cvAppReducer from "../../store/reducers/cvapp-reducer";
const AddWidgetModal = ({
  showModal,
  setShowModal,
  index,
  widgetAdded,
  cvAppConfigedList,
}) => {
  const { activeSession } = useSelector((state) => state.sessionReducer.activeSession);
  //const { siteTagList } = useSelector((state) => state?.sitesReducer);
  const sitesTagLists =
    useSelector((state) => {
      return state.sitesReducer.siteTagList;
    }) || JSON.parse(sessionStorage.getItem("SitesTagList"));
  const [sitesTagList, setSiteTagList] = useState([]);
  const [usersSiteTagListIds, setUsersSiteTagListIds] = useState([]);

  useEffect(() => {
    if(sitesTagLists?.sites){
    setSiteTagList(sitesTagLists?.sites || []);
    setUsersSiteTagListIds(sitesTagLists?.sites.map((m) => m.id));
    }
  }, [sitesTagLists]);

  const [tags, setTags] = useState([]);
  const [listTags, setListTags] = useState([]);
  const cvAppList = useSelector((state) => state.cvAppReducer.cvAppList) || [];
  const filteredcvApps = cvAppList && cvAppList?.filter((app) => app?.category === "Statistics Apps");
  const widgetConfig = useSelector((state) => state.widgetReducer.widgetConfig);
  const dispatch = useDispatch();
  const [filteredSubscribedcvApps, setFilteredSubscribedcvApps] = useState([]);
  const [selectedApp, setSelectedApp] = useState(null);
  const [selectedSite, setSelectedSite] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalSubTitle, setModalSubTitle] = useState("Select the app and site you'd like to add a widget for.");
  

  useEffect(() => {
    if (cvAppConfigedList != undefined && cvAppConfigedList.length > 0 && sitesTagList.length > 0) {
      const roisWithcvApps = cvAppConfigedList.filter((roi) => {
        return (
          roi?.cvapps != undefined &&
          roi?.cvapps[0].category === "Statistics Apps" && 
          roi?.siteids !== undefined && 
          roi?.siteids?.length > 0 && usersSiteTagListIds.includes(roi?.siteids[0])
        );
      });
      const cvAppsWithRepeats = roisWithcvApps?.map((m) => {
        return m.cvapps[0];
      });
      const cvApps = cvAppsWithRepeats?.filter(
        (value, index, self) =>
          index ===
          self.findIndex((t) => t.name === value.name)
      );
      setModalSubTitle(cvApps.length > 0 ? "Select the app and site you'd like to add a widget for." : "No Stats app was subscribed.");
      setFilteredSubscribedcvApps(cvApps);
    }
  }, [cvAppConfigedList, sitesTagList]);


  const fetchCvappsLocation = async (appId, siteId) => {
    setLoading(true);
    setSiteTagList([]);
    try {
      const tagLists = await getCVAppLocationDataFromAppName(appId, activeSession,filteredcvApps, cvAppConfigedList)
      //const tagLists2 = await getCVAppLocationData(appId, activeSession);
      if(tagLists?.length) {
        const sites = [];
        const tagesIds =[];
        const list = [];
       
           tagLists?.map((tags)=>{
            tags?.locationids?.map((tagid) => {
              const matchingListSubAreas = sitesTagLists?.subareas.filter((e) =>e.id === tagid);
              const matchingListAreas = sitesTagLists?.areas.filter((e) =>e.id === tagid);
              const matchingListFloors = sitesTagLists?.floors.filter((e) =>e.id === tagid);
              const matchingListSites = sitesTagLists?.sites.filter((e) =>e.id === tagid);
              //console.log(matchingListSubAreas,matchingListAreas,matchingListFloors, "matching List >>>>");
              if(matchingListSubAreas && matchingListSubAreas.length > 0) {
                const getAreas = sitesTagLists?.areas.filter((e) =>matchingListSubAreas[0].tagids?.includes(e.id));
                const getFloor = getAreas.length > 0 ? sitesTagLists?.floors.filter((e) =>getAreas[0].tagids?.includes(e.id)) : [];
                const getSites = getFloor.length > 0 ? sitesTagLists?.sites.filter((e) =>getFloor[0].tagids?.includes(e.id)) : [];
                if(getSites.length > 0 && getSites[0] && !sites.some((item)=>item.name === getSites[0].name)) {
                  sites.push({id:getSites[0]?.id,name: getSites[0]?.name})
                }
                const ids = [
                        matchingListSubAreas[0]?.id,
                        getAreas.length > 0 ? getAreas[0]?.id : null,
                        getFloor.length > 0 ? getFloor[0]?.id : null
                      ].filter(id => id !== null && id !== undefined);
                      list.push(...ids);
              }
              if(matchingListAreas && matchingListAreas.length > 0) {
                const getFloor = sitesTagLists?.floors.filter((e) =>matchingListAreas[0].tagids?.includes(e.id));
                const getSites = sitesTagLists?.sites.filter((e) =>getFloor[0].tagids?.includes(e.id));
                if(!sites.some((item)=>item.name === getSites[0]?.name) && getSites.length > 0) {
                  sites.push({id:getSites[0]?.id,name: getSites[0]?.name})
                }

                list.push(...[matchingListAreas[0]?.id, getFloor[0]?.id]);
              }
              if(matchingListFloors && matchingListFloors.length > 0) {

                const getSites = sitesTagLists?.sites.filter((e) =>matchingListFloors[0].tagids?.includes(e.id));
                if(!sites.some((item)=>item.name === getSites[0]?.name) && getSites.length > 0) {
                  sites.push({id:getSites[0]?.id,name: getSites[0]?.name})
                }
                list.push(matchingListFloors[0]?.id);
               
              }
              if (matchingListSites && matchingListSites.length > 0) {
                if (selectedSite != null) {
                  list.push(selectedSite);
                }
                if (!sites.some((item) => item?.name === matchingListSites[0]?.name)) {
                  sites.push({ id: matchingListSites[0]?.id, name: matchingListSites[0]?.name });
                }
              }
              if(!tagesIds.includes(tagid)) {
                tagesIds.push(tagid)
              }
            });
            
          });
        
        setSiteTagList(sites);
        setTags(tagesIds);
        setListTags(removeDuplicates(list));
      } 
    } catch (error) {
       console.error("Error:", error);
      
    } finally {
      setLoading(false);
    }
  };
  function removeDuplicates(arr) {
    return [...new Set(arr)];
}

  useEffect(() => {
    if (selectedApp || selectedSite) {
      fetchCvappsLocation(selectedApp, selectedSite);
    }
  }, [selectedApp, selectedSite]);


  
  return (
    <>
      <Modal
        opened={showModal}
        onOpenedChange={(opened) => {
          setShowModal(opened);
          if (!opened) {
            setSelectedSite(null);
            setSelectedApp(null);
            setSelectedSite(null);
            setSelectedLocation(null);
          }
        }}
        surface="light"
        fullScreenDialog={false}
        disableAnimation={false}
        disableOutsideClick={false}
        ariaLabel="Testing Modal"
      >
        <ModalTitle>Add widget</ModalTitle>
        {loading && <Loader active={true} fullscreen={false} />}
        <ModalBody>
          <ModalBodyContent>
            
           {modalSubTitle}
           {filteredSubscribedcvApps.length > 0 && (<>
            <br />
            <br />
            <DropdownSelect
            label="App"
            errorText="At least one type should be selected"
            error={false}
            readOnly={false}
            onChange={(e) => {setTags([]); 
              setSiteTagList([]);
              setSelectedSite("");
              setSelectedApp(e.target.value)}}
            width="100%"
            data-testid= "dashboard_widgetAddWidgetModalSelectAppDropdown"
          >
            <option value="">Select</option>
            {filteredSubscribedcvApps?.length > 0 &&
              filteredSubscribedcvApps?.map((item) => (
                <option key={item?.id} value={item?.id}>
                  {item?.resources?.displayNameFull || item?.name}
                </option>
              ))}
            {/* <option value="peopleCountOA">People count (Open area)</option>
                          <option value="parkingOccupancyEE">Parking occupancy (Entry/exit)</option>
                          <option value="parkingOccupancyOA">Parking occupancy (Open area)</option>
                          <option value="vehicleCountEE">Vehicle count (Entry/exit)</option>
                          <option value="vehicleCountOA">Vehicle count (Open area)</option> */}
          </DropdownSelect>
          <br />
          <DropdownSelect
            label="Site"
            errorText="At least one type should be selected"
            error={false}
            readOnly={false}
            onChange={(e) => {setTags([]); setSelectedSite(e.target.value)}}
            width="100%"
            disabled={!selectedApp}
            data-testid= "dashboard_widgetAddWidgetModalSelectSiteDropdown"
          >
            <option value="">Select</option>
            {sitesTagList &&
              sitesTagList?.map((item) => (
                <option selected={selectedSite === item?.id} key={item?.id} value={item.id}>
                  {item.name}
                </option>
              ))}
          </DropdownSelect>
          <br />
          {selectedSite && (
            <>
              <p>
                Select any location within the site that you would like to add as
                a people count widget.
              </p>
              <TreeViewComponent
                siteid={selectedSite}
                setSelectedLocation={setSelectedLocation}
                tagsIds={tags}
                listTags={listTags}
                selectedApp={filteredSubscribedcvApps?.find(app => app.id === selectedApp)}
                appChangeKey={selectedApp}
              />
            </>
          )}
          </>)}
          </ModalBodyContent>
        </ModalBody>
        <ModalActionsContainer role="contentinfo" aria-label="Modal actions">
          <ButtonGroup
            viewport="desktop"
            childWidth="100%"
            rowQuantity={{ desktop: 2, tablet: 2, mobile: 1 }}
            gap="16px"
            data={[
              {
                children: "Add",
                size: "large",
                use: "primary",
                width: "100%",
                "data-testid": "dashboard_widgetAddModalPrimaryButton",
                onClick: () => {
                  let appname = filteredcvApps.find(l => l.id === selectedApp).name;
                  const roiList = filterRoisWithCvappsAndSiteids(cvAppConfigedList);
                  let roiappended = roiList.filter(f => f.cvapps[0].name === appname && 
                    (f?.customdata?.statisticstagids?.includes(selectedLocation) || f.tagids?.includes(selectedLocation)));
                    let appIdForSelectedRoi = roiappended?.[0]?.cvapps?.[0]?.id || selectedApp;

                  let config = {
                    id: uuidv4(),
                    size: 1,
                    content: {
                      appName: appIdForSelectedRoi,
                      location: selectedLocation,
                    },
                  };
                  dispatch(patchWidgetConfig({
                    customdata: {
                      widgetconfig: widgetConfig?.length ? [...widgetConfig, config] : [config],
                    },
                  }));
                  widgetAdded();
                },
                disabled: !(selectedApp && selectedSite && selectedLocation),
              },
              {
                children: "Cancel",
                size: "large",
                use: "secondary",
                width: "100%",
                "data-testid": "dashboard_widgetAddModalSecondaryButton",
                onClick: () => {
                  setShowModal(false);
                  setSelectedSite(null);
                  setSelectedApp(null);
                  setSelectedLocation(null);
                },
              },
            ]}
          />
        </ModalActionsContainer>
      </Modal>
    </>
  );
};

export default AddWidgetModal;
